<!-- TODO: This page should be broken down into smaller components -->

<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  // TODO - refactor h1 and h2 styling in a neater way
  @mixin dashboard-text-style(
    $font-size,
    $font-weight,
    $line-height,
    $text-transform: none
  ) {
    font-family: "Lato", sans-serif;
    font-size: $font-size !important;
    font-weight: $font-weight;
    line-height: $line-height;
    text-transform: $text-transform;
  }

  :global(h2:where(:not([data-sw-ds])):not(.win-title)) {
    @include dashboard-text-style(clamp(1rem, 0.8vw, 1.25rem), bold, 120%);
  }

  :global(span:where(:not([data-sw-ds])).resize) {
    font-size: clamp(0.8rem, 0.8vw, 0.8rem) !important;
  }

  :global(a:where(:not([data-sw-ds])):not(.no-clamp)) {
    font-size: clamp(0.8rem, 0.8vw, 0.875rem) !important;
  }

  :root {
    --leaderboard-comparison-graph-height: 25rem;
  }

  @media (max-width: 1380px) {
    :root {
      --leaderboard-comparison-graph-height: 22rem;
    }
  }

  h1 {
    @include dashboard-text-style(clamp(1.3rem, 0.8vw, 1.75rem), bold, 120%);
    letter-spacing: 0;
  }

  #dashboardContainer {
    display: grid;
    grid-template-columns: repeat(11, 1fr);
    grid-gap: 1.2rem;
    padding: 1.2rem;

    grid-template-areas:
      "pageNav pageNav pageNav pageNav pageNav pageNav pageNav pageNav pageNav pageNav pageNav"
      "statCard statCard statCard statCard statCard statCard statCard statCard statCard statCard statCard"
      "leaderboard leaderboard leaderboard leaderboard leaderboard leaderboard liveFeed liveFeed liveFeed liveFeed liveFeed"
      "todo todo todo todo todo benchmarks benchmarks benchmarks benchmarks benchmarks benchmarks"
      "todo todo todo todo todo heatmap heatmap heatmap heatmap heatmap heatmap";

    @media (max-width: 1380px) {
      grid-template-columns: repeat(2, 1fr);
      grid-template-areas:
        "pageNav pageNav"
        "statCard statCard"
        "leaderboard leaderboard"
        "todo liveFeed"
        "benchmarks benchmarks"
        "heatmap heatmap";
    }

    @media (max-width: 1100px) {
      grid-template-columns: 1fr;
      grid-template-areas:
        "pageNav"
        "statCard"
        "leaderboard"
        "liveFeed"
        "todo"
        "benchmarks"
        "heatmap";
    }

    > section {
      background-color: white;
      border-radius: 0.625rem;
      display: flex;
      flex-direction: column;
      padding: 1.3rem;

      .sectionNav {
        align-items: center;
        display: flex;
        margin-bottom: 1rem;
        justify-content: space-between;

        .sectionTitle {
          display: flex;
          align-items: center;
          margin-right: 0.5rem;

          h2 {
            margin-bottom: 0;
            text-wrap: nowrap;
          }
        }

        &.remove-bottom-margin {
          margin-bottom: 0;
        }

        h2 {
          color: $text-black;
          display: inline-flex;
          margin-right: 1rem;
        }

        // TODO - dropdowns are just too big
        &Dropdowns {
          align-items: stretch;
          display: flex;
          gap: 0.75rem;
          flex-wrap: wrap;
          justify-content: flex-end;
        }
      }

      .inlineNotification {
        margin-top: 0.25rem;
        margin-bottom: 0.5rem;

        @extend .text-body-2;
        font-size: clamp(0.8rem, 0.8vw, 0.875rem);
        a {
          color: $primary-color;
          &:hover {
            color: $dark-blue;
          }
        }
      }

      &#pageNav {
        background-color: transparent;
        grid-area: pageNav;
        padding: 0;
        .sectionNav {
          margin-bottom: 0rem;
        }
      }

      &#statCardContainer {
        grid-area: statCard;
        font-size: clamp(0.8rem, 0.8vw, 1rem);

        #statCardGrid {
          display: grid;
          gap: 1.25rem;
          grid-template-columns: repeat(5, 1fr);

          @media (max-width: 1100px) {
            grid-template-columns: repeat(3, 1fr);
          }

          @media (max-width: 700px) {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      }

      &#leaderboardContainer {
        grid-area: leaderboard;
        @media (max-width: 1380px) {
          padding-bottom: 3rem;
        }

        .blankLeaderboardText {
          display: flex;
          width: 16rem;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }
      }

      &#liveFeedContainer {
        grid-area: liveFeed;

        .sectionNav {
          flex-wrap: wrap;
          gap: 0.5rem;

          .sectionTitle {
            ul {
              padding: 0;
              margin: 0.1rem; // prevents odd text jump
              margin-right: 0.5rem;
            }
          }
        }
      }

      &#todoContainer {
        max-height: 70rem;
        grid-area: todo;

        .sectionNav {
          flex-wrap: wrap;
          gap: 0.5rem;

          .sectionNavDropdowns {
            display: flex;
            flex-wrap: wrap;
            gap: 0.75rem;
            justify-content: normal;
          }
        }

        #skeletonDatePickerContainer {
          display: grid;
          gap: 0.625rem;
          grid-template-columns: repeat(7, 1fr);
          margin-bottom: 2rem;
        }
      }

      &#benchmarksContainer {
        max-height: 32rem;
        grid-area: benchmarks;
      }

      &#heatmapContainer {
        grid-area: heatmap;
      }
    }
  }
</style>

<script>
  import TabItem from "@sourcewhale/shared/svelte-design-system/components/atoms/TabItem.svelte";
  import { setContext } from "svelte";
  import { writable } from "svelte/store";
  import Dropdown from "../../components/legacy/Dropdown/Dropdown.svelte";
  import SkeletonLoading from "../../components/legacy/SkeletonLoading.svelte";
  import Tooltip from "../../components/legacy/Tooltip.svelte";
  import BlankLeaderboard from "./BlankLeaderboard.svelte";
  import ComparisonGraph from "./ComparisonGraph.svelte";
  import DashboardInfoIcon from "./DashboardInfoIcon.svelte";
  import DashboardRefreshButton from "./DashboardRefreshButton.svelte";
  import DashboardSearch from "./DashboardSearch/DashboardSearch.svelte";
  import DashboardToggle from "./DashboardToggle.svelte";
  import Heatmap from "./Heatmap.svelte";
  import LeaderboardRanking from "./LeaderboardRanking/LeaderboardRanking.svelte";
  import LeaderboardTableRanking from "./LeaderboardTableRanking.svelte";
  import LiveFeed from "./LiveFeed/LiveFeed.svelte";
  import StatCard from "./StatCard.svelte";
  import { dashboardTodosStore, initDashboardStores } from "./stores";
  import Table from "./Table.svelte";
  import Todos from "./Todos/Todos.svelte";
  import {
    getBenchmarksData,
    getHeatmapData,
    getLeaderboardData,
    getStatCardData,
  } from "./utils/apiCalls";
  import {
    benchmarksActivityOptions,
    transformBenchmarksDataForTable,
  } from "./utils/benchmarks";
  import {
    campaignTypeOptions,
    selectedCampaignType,
    updateSelectedCampaignType,
  } from "./utils/campaignTypes";
  import { heatmapActivityOptions, storedHeatmapUser } from "./utils/heatmap";
  import {
    leaderboardActivityOptions,
    leaderboardGroups,
  } from "./utils/leaderboard";
  import { liveFeedActivityOptions } from "./utils/liveFeed";
  import {
    nullStatCardStats,
    statCardGroupUserFilterOptions,
    statCardUsersFilteredByGroups,
  } from "./utils/statCard";
  import {
    benchmarksActivityOption,
    benchmarksData,
    benchmarksDataLoading,
    checkedToDos,
    filteredToDoActivityOptions,
    heatmapData,
    heatmapOption,
    initialHeatmapLoading,
    leaderboardActivityOption,
    leaderboardData,
    leaderboardDataLoading,
    liveFeedRefreshButtonState,
    refreshLiveFeed,
    selectedHeatmapUser,
    selectedLeaderboardGroupOptions,
    selectedLiveFeedActivityOptions,
    selectedLiveFeedTabState,
    selectedStatCardGroups,
    selectedStatCardUserGroupFilter,
    selectedStatCardUserIds,
    selectedStatCardUsers,
    selectedToDosActivityOptions,
    selectedToDosCampaignOptions,
    statCardData,
    statCardDataLoading,
    toDosCampaignOptions,
    toDosRefreshButtonState,
  } from "./utils/stores";
  import {
    handleTimeOptionChange,
    selectedBenchmarksTimeOption,
    selectedHeatmapTimeOption,
    selectedLeaderboardTimeOption,
    selectedStatCardTimeOption,
    timeOptions,
  } from "./utils/timePeriods";
  import { selectedToDosUser } from "./utils/toDos";
  import {
    defaultSelectedUser,
    groups,
    isDashboardAdmin,
    showCampaignTypes,
    teamId,
    users,
  } from "./utils/usersAndGroups";
  import {
    arraysHaveSameStrings,
    getFromLocalStorage,
    getStickyMultiOptions,
    returnArrayWithLargestValue,
    saveToLocalStorage,
  } from "./utils/utils";
  import {
    handleBenchmarksViewToggle,
    handleLeaderboardViewToggle,
    selectedBenchmarksView,
    selectedLeaderboardView,
  } from "./utils/views";

  initDashboardStores();
  /* ------------- */
  /* CAMPAIGN TYPE */
  /* ------------- */

  setContext("selectedCampaignType", selectedCampaignType);

  const handleCampaignTypeChange = (event) => {
    const campaignType = event.detail[0];
    if (campaignType.value !== $selectedCampaignType.value) {
      updateSelectedCampaignType(campaignType);
    }
  };

  /* --------- */
  /* LIVE FEED */
  /* --------- */

  const defaultLiveFeedSelectedUsers = () => {
    const defaultUsers = defaultSelectedUser ? [defaultSelectedUser] : users;
    if ($isDashboardAdmin) {
      return getStickyMultiOptions("liveFeedUsers", users, defaultUsers);
    }
    return defaultUsers;
  };

  const selectedLiveFeedUsers = writable(defaultLiveFeedSelectedUsers());

  const handleLiveFeedUsersChange = (event) => {
    const newSelectedUserIds = event.detail.map((user) => user.value);
    const oldSelectedUserIds = $selectedLiveFeedUsers.map((user) => user.value);

    if (!arraysHaveSameStrings(newSelectedUserIds, oldSelectedUserIds)) {
      selectedLiveFeedUsers.set(event.detail);
      saveToLocalStorage("liveFeedUsers", event.detail);
    }
  };

  const handleLiveFeedActivityOptionsChange = (event) => {
    const newSelectedOptions = event.detail.map((option) => option.value);
    const oldSelectedOptions = $selectedLiveFeedActivityOptions.map(
      (option) => option.value
    );

    if (!arraysHaveSameStrings(newSelectedOptions, oldSelectedOptions)) {
      selectedLiveFeedActivityOptions.set(event.detail);
      saveToLocalStorage("selectedLiveFeedActivityOptions", event.detail);
    }
  };

  /* --------- */
  /* STAT CARD */
  /* --------- */

  let isStatCardUserGroupFilterOpen = false;
  let isStatCardUserDropdownOpen = false;
  let isStatCardGroupDropdownOpen = false;
  let isStatCardTooltipSelected = false;

  let statCardPayload = {};

  const handleStatCardUserGroupFilterChange = (option) => {
    if (option.value !== $selectedStatCardUserGroupFilter.value) {
      selectedStatCardUserGroupFilter.set(option);
      saveToLocalStorage("statCardUserGroupFilter", option);
    }
  };

  const handleStatCardUserOptionChange = (event) => {
    const selectedUserIds = event.detail.map((user) => user.value);
    if (!arraysHaveSameStrings(selectedUserIds, $selectedStatCardUserIds)) {
      saveToLocalStorage("selectedStatCardUsers", event.detail);
      selectedStatCardUsers.set(event.detail);
    }
  };

  const handleStatCardGroupOptionChange = (event) => {
    const selectedGroupIds = event.detail.map((group) => group.value);
    if (
      !arraysHaveSameStrings(
        selectedGroupIds,
        $selectedStatCardGroups.map((group) => group.value)
      )
    ) {
      saveToLocalStorage("selectedStatCardGroups", event.detail);
      selectedStatCardGroups.set(event.detail);
    }
  };

  $: {
    if ($selectedStatCardUserGroupFilter.value === "users" || !groups.length) {
      selectedStatCardUserIds.set(
        $selectedStatCardUsers.map((user) => user.value)
      );
    } else if ($selectedStatCardGroups.length) {
      selectedStatCardUserIds.set(
        statCardUsersFilteredByGroups($selectedStatCardGroups).map(
          (user) => user.value
        )
      );
    } else {
      selectedStatCardUserIds.set([]);
    }
  }

  const fetchStatCardData = async (data) => {
    if (!data.userIds.length) {
      statCardData.set({
        stats: nullStatCardStats,
        selectedDates: { startDate: "", endDate: "" },
      });
      statCardDataLoading.set(false);
      return;
    }

    try {
      statCardDataLoading.set(true);
      const response = await getStatCardData(data);
      statCardData.set(response);
    } finally {
      statCardDataLoading.set(false);
    }
  };

  $: {
    statCardPayload = {
      timePeriod: $selectedStatCardTimeOption.option.value,
      campaignType: $selectedCampaignType.value,
      userIds: $selectedStatCardUserIds,
    };
    fetchStatCardData(statCardPayload);
  }

  /* ----------- */
  /* LEADERBOARD */
  /* ----------- */

  let leaderboardPayload = {};
  let selectedLeaderboardUsers = [];
  let filteredLeaderboardStats = [];
  let leaderboardTicks = [];

  let showNullLeaderboard = false;

  let isLeaderboardTooltipSelected = false;

  let leaderboardSortBy = getFromLocalStorage("leaderboardSortBy") || "sourced";
  $: saveToLocalStorage("leaderboardSortBy", leaderboardSortBy);

  if (groups.length) {
    selectedLeaderboardGroupOptions.subscribe((selected) => {
      selectedLeaderboardUsers = users.filter((user) => {
        const selectedGroupIds = selected.map((group) => group.value);
        const userGroupIds = user.groupIds.length
          ? user.groupIds
          : ["unassignedUsers"];
        return userGroupIds.some((id) => selectedGroupIds.includes(id));
      });
    });
  }

  const fetchLeaderboardData = async (data) => {
    try {
      leaderboardDataLoading.set(true);
      const response = await getLeaderboardData(data);
      leaderboardData.set(response);
    } finally {
      leaderboardDataLoading.set(false);
    }
  };

  const handleLeaderboardActivityChange = (selectedOption) => {
    leaderboardActivityOption.set(selectedOption);
    saveToLocalStorage("leaderboard", selectedOption.value);
  };

  const handleLeaderboardGroupOptionChange = (event) => {
    saveToLocalStorage("selectedLeaderboardGroupOptions", event.detail);
    selectedLeaderboardGroupOptions.set(event.detail);
  };

  $: {
    if (Object.keys($leaderboardData).length) {
      if (!groups.length) {
        filteredLeaderboardStats = $leaderboardData.stats;
        leaderboardTicks =
          $leaderboardData.ticks.allUsers[$leaderboardActivityOption.value] ||
          [];
        showNullLeaderboard = false;
      } else if (selectedLeaderboardUsers.length) {
        filteredLeaderboardStats = $leaderboardData.stats.filter((user) =>
          selectedLeaderboardUsers.map((u) => u.value).includes(user.userId)
        );

        const tickOptions = Object.entries($leaderboardData.ticks).map(
          ([groupId, ticks]) => ({
            groupId,
            ticks: ticks[$leaderboardActivityOption.value],
          })
        );

        const filteredTickOptions = tickOptions.filter((option) =>
          $selectedLeaderboardGroupOptions
            .map((group) => group.value)
            .includes(option.groupId)
        );

        leaderboardTicks = returnArrayWithLargestValue(
          filteredTickOptions.map((option) => option.ticks)
        );
        showNullLeaderboard = false;
      } else {
        showNullLeaderboard = true;
      }
    }
  }

  $: {
    leaderboardPayload = {
      timePeriod: $selectedLeaderboardTimeOption.option.value,
      campaignType: $selectedCampaignType.value,
    };
    fetchLeaderboardData(leaderboardPayload);
  }

  /* ---------- */
  /* BENCHMARKS */
  /* ---------- */

  let isBenchmarksTooltipSelected = false;
  let numberOfBenchmarkSkeletons = 1;
  if (defaultSelectedUser) numberOfBenchmarkSkeletons += 1;
  if (groups.length) {
    numberOfBenchmarkSkeletons += groups.filter(
      (group) => group.isCurrentUsersGroup
    ).length;
  }

  let benchmarksPayload = {};

  const fetchBenchmarksData = async (data) => {
    try {
      benchmarksDataLoading.set(true);
      const response = await getBenchmarksData(data);
      benchmarksData.set(response);
    } finally {
      benchmarksDataLoading.set(false);
    }
  };

  const handleBenchmarksTimeOptionChange = (event) => {
    const timeOption = event.detail[0];
    if (timeOption.value !== $selectedBenchmarksTimeOption.option.value) {
      benchmarksDataLoading.set(true);
      handleTimeOptionChange(selectedBenchmarksTimeOption, timeOption);
    }
  };

  const handleBenchmarksActivityChange = (selectedOption) => {
    benchmarksActivityOption.set(selectedOption);
    saveToLocalStorage("benchmarks", selectedOption.value);
  };

  $: {
    benchmarksPayload = {
      timePeriod: $selectedBenchmarksTimeOption.option.value,
      campaignType: $selectedCampaignType.value,
    };
    fetchBenchmarksData(benchmarksPayload);
  }

  /* ------------------------ */
  /* HEATMAP (EMAIL TRACKING) */
  /* ------------------------ */

  let heatmapPayload = {};
  let heatmapUsersAndGroups = [];
  let heatmapDataLoading = true;

  const fetchHeatmapData = async (data) => {
    try {
      heatmapDataLoading = true;
      const response = await getHeatmapData(data);
      heatmapData.set(response);
    } finally {
      heatmapDataLoading = false;
    }
  };

  const handleHeatmapTimeOptionChange = (event) => {
    const timeOption = event.detail[0];
    if (timeOption.value !== $selectedHeatmapTimeOption.option.value) {
      heatmapDataLoading = true;
      handleTimeOptionChange(selectedHeatmapTimeOption, timeOption);
    }
  };

  const handleHeatmapKindChange = (selectedOption) => {
    heatmapOption.set(selectedOption);
    saveToLocalStorage("heatmap", selectedOption.value);
  };

  const handleHeatmapUserChange = (selectedOption) => {
    selectedHeatmapUser.set(selectedOption);
    saveToLocalStorage("heatmapUser", selectedOption);
  };

  $: {
    heatmapPayload = {
      timePeriod: $selectedHeatmapTimeOption.option.value,
      campaignType: $selectedCampaignType.value,
    };
    fetchHeatmapData(heatmapPayload);
  }

  $: {
    if ($initialHeatmapLoading && Object.keys($heatmapData).length) {
      heatmapUsersAndGroups = Object.entries($heatmapData).map(
        ([key, value]) => ({
          value: key,
          label: value.label,
        })
      );

      if (storedHeatmapUser) {
        selectedHeatmapUser.set(
          heatmapUsersAndGroups
            .map((x) => x.value)
            .includes(storedHeatmapUser.value)
            ? storedHeatmapUser
            : heatmapUsersAndGroups.find((option) => option.value === teamId)
        );
      } else {
        selectedHeatmapUser.set(
          heatmapUsersAndGroups.find((option) => option.value === teamId)
        );
      }
      initialHeatmapLoading.set(false);
    }
  }

  /* ------ */
  /* TO-DOS */
  /* ------ */
  const dashboardTodosStoreMeta = dashboardTodosStore.meta;
  const handleSelectedToDosUserChange = (event) => {
    const user = event.detail[0];
    if (user.value !== $selectedToDosUser.value) {
      selectedToDosUser.set(user);
      saveToLocalStorage("selectedToDosUser", user);
    }
  };

  const handleToDosActivityOptionsChange = (event) => {
    const newSelectedOptions = event.detail.map((option) => option.value);
    const oldSelectedOptions = $selectedToDosActivityOptions.map(
      (option) => option.value
    );
    if (!arraysHaveSameStrings(newSelectedOptions, oldSelectedOptions)) {
      selectedToDosActivityOptions.set(event.detail);
      saveToLocalStorage("selectedToDosActivityOptions", event.detail);
    }
  };

  const handleToDosCampaignOptionsChange = (event) => {
    const newSelectedOptions = event.detail.map((option) => option.value);
    const oldSelectedOptions = $selectedToDosCampaignOptions.map(
      (option) => option.value
    );
    if (!arraysHaveSameStrings(newSelectedOptions, oldSelectedOptions)) {
      saveToLocalStorage("selectedToDosCampaignOptions", event.detail);
      selectedToDosCampaignOptions.set(event.detail);
    }
  };

  const refreshToDos = () => dashboardTodosStore.get();
</script>

<main>
  <div id="dashboardContainer">
    <!-- PAGE NAV -->
    <section id="pageNav">
      <div class="sectionNav" style="align-items:end">
        <h1>Dashboard</h1>
        <div class="sectionNavDropdowns">
          {#if showCampaignTypes}
            <Dropdown
              options={campaignTypeOptions}
              selected={$selectedCampaignType}
              confirmDropdownOnClose
              on:dropdown-confirmation={handleCampaignTypeChange}
            />
          {/if}
          <DashboardSearch />
        </div>
      </div>
    </section>
    <!-- STAT CARDS -->
    <section id="statCardContainer">
      <div class="sectionNav">
        <div class="sectionTitle" style="align-items:end;">
          <h2>
            <Dropdown
              options={timeOptions.statCard}
              selected={$selectedStatCardTimeOption.option}
              naked
              confirmDropdownOnClose
              inactive={$statCardDataLoading}
              on:dropdown-confirmation={(event) =>
                handleTimeOptionChange(
                  selectedStatCardTimeOption,
                  event.detail[0]
                )}
            />
          </h2>
          <Tooltip
            width="15rem"
            fontSize="14px"
            xPlacement="right"
            yPlacement="bottom"
            dispatchMouseEvents
            on:tooltip-enter={() => {
              isStatCardTooltipSelected = true;
            }}
            on:tooltip-leave={() => {
              isStatCardTooltipSelected = false;
            }}
          >
            <i slot="target"
              ><DashboardInfoIcon
                bind:highlight={isStatCardTooltipSelected}
              /></i
            >
            <span slot="content">
              These stat cards show your team's overall performance metrics.<br
              />You can compare team stats across different time periods to
              track progress.<br />Use the dropdown to view stats for specific
              team members.
            </span>
          </Tooltip>
        </div>
        <div class="sectionNavDropdowns">
          {#if groups.length}
            <Dropdown
              options={statCardGroupUserFilterOptions}
              selected={$selectedStatCardUserGroupFilter}
              naked
              dropdownLabel="Filter by"
              bind:isOpen={isStatCardUserGroupFilterOpen}
              callback={handleStatCardUserGroupFilterChange}
            />
          {/if}
          {#if !groups.length || $selectedStatCardUserGroupFilter.value === "users"}
            <Dropdown
              options={users}
              placeholder="Select a User"
              selected={$selectedStatCardUsers}
              allSelectedText="All Users"
              multiple
              searchable
              displayInitials
              confirmDropdownOnClose
              calculateSecondaryLabels
              secondaryLabelKey="domain"
              bind:isOpen={isStatCardUserDropdownOpen}
              on:dropdown-confirmation={handleStatCardUserOptionChange}
            />
          {:else}
            <Dropdown
              options={leaderboardGroups}
              selected={$selectedStatCardGroups}
              placeholder="Select a Group"
              allSelectedText="All Groups"
              displayInitials
              multiple
              confirmDropdownOnClose
              bind:isOpen={isStatCardGroupDropdownOpen}
              on:dropdown-confirmation={handleStatCardGroupOptionChange}
            />
          {/if}
        </div>
      </div>
      <div id="statCardGrid">
        {#if $statCardDataLoading}
          {#each Array.from({ length: 5 }) as _}
            <SkeletonLoading
              containerStyles={{ gap: "1rem" }}
              itemStyles={{ height: "7.385rem", borderRadius: "0.375rem" }}
              itemCount="1"
            />
          {/each}
        {:else}
          {#each Object.entries($statCardData.stats) as [key, stat]}
            <StatCard {key} {stat} />
          {/each}
        {/if}
      </div>
    </section>
    <!-- LEADERBOARD -->
    <section id="leaderboardContainer">
      <div class="sectionNav remove-bottom-margin">
        <div class="sectionTitle" style="align-items:end;">
          {#if $selectedLeaderboardView === "graph"}
            <h2>
              Leaderboard by&nbsp;
              <Dropdown
                options={leaderboardActivityOptions}
                selected={$leaderboardActivityOption}
                naked
                callback={handleLeaderboardActivityChange}
              />
            </h2>
          {:else}
            <h2>Leaderboard</h2>
          {/if}
          <Tooltip
            width="15rem"
            fontSize="14px"
            xPlacement="right"
            yPlacement="top"
            dispatchMouseEvents
            on:tooltip-enter={() => {
              isLeaderboardTooltipSelected = true;
            }}
            on:tooltip-leave={() => {
              isLeaderboardTooltipSelected = false;
            }}
          >
            <i slot="target"
              ><DashboardInfoIcon
                bind:highlight={isLeaderboardTooltipSelected}
              /></i
            >
            <span slot="content">
              See how your team ranks on key metrics like calls, replies, and
              meetings. Switch between bar chart or table views for detailed
              insights.
            </span>
          </Tooltip>
        </div>
        <div class="sectionNavDropdowns">
          {#if groups.length}
            <Dropdown
              options={leaderboardGroups}
              selected={$selectedLeaderboardGroupOptions}
              placeholder="Select a Group"
              allSelectedText="All Groups"
              displayInitials
              multiple
              reactToEachSelection
              on:selection-event={handleLeaderboardGroupOptionChange}
            />
          {/if}
          <Dropdown
            options={timeOptions.leaderboard}
            selected={$selectedLeaderboardTimeOption.option}
            inactive={$leaderboardDataLoading}
            confirmDropdownOnClose
            on:dropdown-confirmation={(event) =>
              handleTimeOptionChange(
                selectedLeaderboardTimeOption,
                event.detail[0]
              )}
          />
          <DashboardToggle
            selected={$selectedLeaderboardView}
            on:toggle-view={handleLeaderboardViewToggle}
          />
        </div>
      </div>
      <div class="inlineNotification">
        <span
          >Want more detailed insights? <a
            href="/reports?tab=team"
            target="_blank">Visit the Reports page</a
          ></span
        >
      </div>
      {#if $leaderboardDataLoading || !Object.keys($leaderboardData).length}
        <SkeletonLoading
          containerStyles={{ gap: "1rem" }}
          itemStyles={{ height: "2.8125rem", borderRadius: "0.375rem" }}
          itemCount={9}
        />
      {:else if showNullLeaderboard}
        <BlankLeaderboard>
          <span class="blankLeaderboardText"
            >Select a group from the dropdown menu to view the leaderboard</span
          >
        </BlankLeaderboard>
      {:else if $selectedLeaderboardView === "graph"}
        <LeaderboardRanking
          data={filteredLeaderboardStats}
          selectedLeaderboardOption={$leaderboardActivityOption.value}
          dataType={leaderboardActivityOptions.find(
            (opt) => opt.value === $leaderboardActivityOption.value
          ).type}
        />
        <ComparisonGraph
          ticks={leaderboardTicks}
          data={filteredLeaderboardStats}
          dataKey={$leaderboardActivityOption.value}
          dataType={leaderboardActivityOptions.find(
            (option) => option.value === $leaderboardActivityOption.value
          ).type}
          showRanking
          height="var(--leaderboard-comparison-graph-height)"
        />
      {:else if $selectedLeaderboardView === "table"}
        <LeaderboardTableRanking
          {filteredLeaderboardStats}
          bind:leaderboardSortBy
        />
      {/if}
    </section>
    <!-- LIVE FEED -->
    <section id="liveFeedContainer">
      <div class="sectionNav">
        <div class="sectionTitle" style="gap:0.5rem;">
          <ul>
            <TabItem
              label="Live Feed"
              active={$selectedLiveFeedTabState === "liveFeed"}
              onclick={() => {
                selectedLiveFeedTabState.set("liveFeed");
              }}
            />
            <TabItem
              label="Hotlist"
              active={$selectedLiveFeedTabState === "hotlist"}
              onclick={() => {
                selectedLiveFeedTabState.set("hotlist");
              }}
            />
          </ul>
          <DashboardRefreshButton
            stateStore={liveFeedRefreshButtonState}
            on:refresh-click={() => {
              refreshLiveFeed.set(true);
              liveFeedRefreshButtonState.set("active");
            }}
          />
        </div>
        <div class="sectionNavDropdowns">
          {#if $isDashboardAdmin}
            <Dropdown
              options={users}
              placeholder="Select a User"
              selected={$selectedLiveFeedUsers}
              allSelectedText="All Users"
              secondaryLabelKey="domain"
              confirmDropdownOnClose
              calculateSecondaryLabels
              displayInitials
              multiple
              searchable
              truncateLength="10"
              on:dropdown-confirmation={handleLiveFeedUsersChange}
            />
          {/if}
          {#if $selectedLiveFeedTabState !== "hotlist"}
            <Dropdown
              options={liveFeedActivityOptions}
              selected={$selectedLiveFeedActivityOptions}
              selectAllText="All Activities"
              placeholder="Select an Activity"
              allSelectedText="All Activities"
              multiple
              displayInitials
              confirmDropdownOnClose
              on:dropdown-confirmation={handleLiveFeedActivityOptionsChange}
            />
          {/if}
        </div>
      </div>
      {#if $selectedLiveFeedTabState === "hotlist"}
        <LiveFeed selectedUsers={$selectedLiveFeedUsers} kinds={["hotlist"]} />
      {:else}
        <LiveFeed
          selectedUsers={$selectedLiveFeedUsers}
          kinds={$selectedLiveFeedActivityOptions.map((kind) => kind.value)}
        />
      {/if}
    </section>
    <!-- TO-DOS -->
    <section id="todoContainer">
      {#if users.length}
        <div class="sectionNav">
          <div class="sectionTitle">
            <h2>To-Dos</h2>
            <DashboardRefreshButton
              stateStore={toDosRefreshButtonState}
              on:refresh-click={refreshToDos}
            />
          </div>
          <div class="sectionNavDropdowns">
            {#if $isDashboardAdmin}
              <Dropdown
                options={users}
                placeholder="Select a User"
                selected={$selectedToDosUser}
                inactive={$checkedToDos.length}
                secondaryLabelKey="domain"
                searchable
                confirmDropdownOnClose
                calculateSecondaryLabels
                rightAuto
                on:dropdown-confirmation={handleSelectedToDosUserChange}
              />
            {/if}
            {#if !$dashboardTodosStoreMeta.fetching}
              <Dropdown
                options={$filteredToDoActivityOptions}
                placeholder="Select Outreach"
                selected={$selectedToDosActivityOptions}
                allSelectedText="All Outreach"
                inactive={$checkedToDos.length}
                multiple
                displayInitials
                reactToEachSelection
                on:selection-event={handleToDosActivityOptionsChange}
              />
              {#if $toDosCampaignOptions.length}
                <Dropdown
                  options={$toDosCampaignOptions}
                  selected={$selectedToDosCampaignOptions}
                  allSelectedText="All Campaigns"
                  placeholder="Select a Campaign"
                  inactive={$checkedToDos.length}
                  dropdownMenuMaxWidth="37rem"
                  multiple
                  displayInitials
                  searchable
                  reactToEachSelection
                  rightAuto
                  truncateLength="25"
                  on:selection-event={handleToDosCampaignOptionsChange}
                />
              {/if}
            {/if}
          </div>
        </div>
        {#if $dashboardTodosStoreMeta.fetching}
          <div id="skeletonDatePickerContainer">
            {#each Array.from({ length: 7 }) as _}
              <SkeletonLoading
                containerStyles={{ gap: "1rem" }}
                itemStyles={{ height: "5rem", borderRadius: "0.375rem" }}
                itemCount={1}
              />
            {/each}
          </div>
          <SkeletonLoading
            containerStyles={{ gap: "1rem" }}
            itemStyles={{ height: "2.6125rem", borderRadius: "0.375rem" }}
            itemCount={11}
          />
        {:else}
          <Todos />
        {/if}
      {:else}
        <div class="sectionNav">
          <div class="sectionTitle">
            <h2>To-Dos</h2>
          </div>
        </div>
        <div id="skeletonDatePickerContainer">
          {#each Array.from({ length: 7 }) as _}
            <SkeletonLoading
              containerStyles={{ gap: "1rem" }}
              itemStyles={{ height: "5rem", borderRadius: "0.375rem" }}
              itemCount={1}
              noAnimation
            />
          {/each}
        </div>
        <SkeletonLoading
          containerStyles={{ gap: "1rem" }}
          itemStyles={{ height: "2.6125rem", borderRadius: "0.375rem" }}
          itemCount={11}
          noAnimation
        />
      {/if}
    </section>
    <!-- BENCHMARKS -->
    <section id="benchmarksContainer">
      <div class="sectionNav">
        <div class="sectionTitle" style="align-items:end;">
          {#if $selectedBenchmarksView === "graph"}
            <h2>
              Benchmarks by&nbsp;
              <Dropdown
                options={benchmarksActivityOptions}
                selected={$benchmarksActivityOption}
                naked
                callback={handleBenchmarksActivityChange}
              />
            </h2>
          {:else}
            <h2>Benchmarks</h2>
          {/if}
          <Tooltip
            width="16rem"
            fontSize="14px"
            xPlacement="right"
            yPlacement="top"
            dispatchMouseEvents
            on:tooltip-enter={() => {
              isBenchmarksTooltipSelected = true;
            }}
            on:tooltip-leave={() => {
              isBenchmarksTooltipSelected = false;
            }}
          >
            <i slot="target"
              ><DashboardInfoIcon
                bind:highlight={isBenchmarksTooltipSelected}
              /></i
            >
            <span slot="content">
              Compare your stats for clicks, opens, replies, and interested
              against your team and the SourceWhale average. The SourceWhale
              average updates every 30 days to keep you up-to-date on industry
              trends.
            </span>
          </Tooltip>
        </div>
        <div class="sectionNavDropdowns">
          <Dropdown
            options={timeOptions.benchmarks}
            selected={$selectedBenchmarksTimeOption.option}
            confirmDropdownOnClose
            on:dropdown-confirmation={handleBenchmarksTimeOptionChange}
          />
          <DashboardToggle
            selected={$selectedBenchmarksView}
            on:toggle-view={handleBenchmarksViewToggle}
          />
        </div>
      </div>
      {#if $benchmarksDataLoading}
        {#if $selectedBenchmarksView === "graph"}
          <SkeletonLoading
            containerStyles="gap: 1.8125rem"
            itemStyles="height: 2.8125rem; border-radius: 0.375rem"
            itemCount={Math.min(numberOfBenchmarkSkeletons, 4)}
          />
        {:else if $selectedBenchmarksView === "table"}
          <SkeletonLoading
            containerStyles="padding-top: 1rem; padding-bottom: 1rem"
            itemStyles="height: 3.6125rem; border-radius: 0.375rem"
            itemCount="1"
          />
          <SkeletonLoading
            containerStyles="gap: 1rem"
            itemStyles="height: 2.6125rem; border-radius: 0.375rem"
            itemCount="4"
          />
        {/if}
      {:else if $selectedBenchmarksView === "graph"}
        <ComparisonGraph
          ticks={$benchmarksData.ticks[$benchmarksActivityOption.value]}
          data={$benchmarksData.stats}
          dataKey={$benchmarksActivityOption.value}
          overallAverage={$benchmarksData.overallAverage}
          graphBarHeight="1"
          rowGap="2.5rem"
          prioritizeCurrentUser
          bottomPadding="3rem"
          height="22rem"
        />
      {:else}
        <Table
          data={transformBenchmarksDataForTable($benchmarksData)}
          columns={$benchmarksData.columns}
          component="benchmarks"
          height="fit-content"
          headerCellFontSize="clamp(0.55rem, 0.8vw, 0.65rem)"
        />
      {/if}
    </section>
    <!-- HEATMAP -->
    <section id="heatmapContainer">
      <div class="sectionNav">
        <div class="sectionTitle">
          <h2>
            Email Tracking by&nbsp;
            <Dropdown
              options={heatmapActivityOptions}
              selected={$heatmapOption}
              naked
              callback={handleHeatmapKindChange}
            />
          </h2>
        </div>
        <div class="sectionNavDropdowns">
          {#if Object.keys($heatmapData).length && Object.keys($selectedHeatmapUser).length}
            <Dropdown
              options={heatmapUsersAndGroups}
              selected={$selectedHeatmapUser}
              placeholder="Select User or Group"
              inactive={heatmapDataLoading}
              dropup
              callback={handleHeatmapUserChange}
            />
          {/if}
          <Dropdown
            options={timeOptions.heatmap}
            selected={$selectedHeatmapTimeOption.option}
            confirmDropdownOnClose
            dropup
            on:dropdown-confirmation={handleHeatmapTimeOptionChange}
          />
        </div>
      </div>
      {#if heatmapDataLoading || !Object.keys($heatmapData).length || !Object.keys($selectedHeatmapUser).length}
        <SkeletonLoading
          containerStyles={{ gap: "1rem" }}
          itemStyles={{ height: "14.6125rem", borderRadius: "0.375rem" }}
          itemCount={1}
        />
      {:else}
        <Heatmap />
      {/if}
    </section>
  </div>
</main>
